import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import ShippingGuidePage from "../pages/article/shipping/page";
import WarehouseGuidePage from "../pages/article/warehouse/page";
import CouponGuidePage from "../pages/article/coupon/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/article/sugargoo-spreadsheet-guide",
    element: <ArticlePage />,
  },
  {
    path: "/article/sugargoo-shipping-cost-guide",
    element: <ShippingGuidePage />,
  },
  {
    path: "/article/sugargoo-warehouse-guide",
    element: <WarehouseGuidePage />,
  },
  {
    path: "/article/sugargoo-coupon-discount-guide",
    element: <CouponGuidePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;